import $ from "jquery"
import { MarkerClusterer } from "@googlemaps/markerclusterer"
const googleMaps = () => {
	const mapStyles = [
		{
			featureType: "all",
			elementType: "labels.text",
			stylers: [
				{
					color: "#878787",
				},
			],
		},
		{
			featureType: "all",
			elementType: "labels.text.stroke",
			stylers: [
				{
					visibility: "off",
				},
			],
		},
		{
			featureType: "landscape",
			elementType: "all",
			stylers: [
				{
					color: "#f9f5ed",
				},
			],
		},
		{
			featureType: "poi.attraction",
			elementType: "all",
			stylers: [
				{
					visibility: "off",
				},
			],
		},
		{
			featureType: "poi.business",
			elementType: "all",
			stylers: [
				{
					visibility: "off",
				},
			],
		},
		{
			featureType: "poi.place_of_worship",
			elementType: "all",
			stylers: [
				{
					visibility: "off",
				},
			],
		},
		{
			featureType: "poi.sports_complex",
			elementType: "all",
			stylers: [
				{
					visibility: "off",
				},
			],
		},
		{
			featureType: "road.highway",
			elementType: "all",
			stylers: [
				{
					color: "#f5f5f5",
				},
			],
		},
		{
			featureType: "road.highway",
			elementType: "geometry.stroke",
			stylers: [
				{
					color: "#c9c9c9",
				},
			],
		},
		{
			featureType: "transit.station",
			elementType: "labels.icon",
			stylers: [
				{
					visibility: "off",
				},
			],
		},
		{
			featureType: "water",
			elementType: "all",
			stylers: [
				{
					color: "#aee0f4",
				},
			],
		},
	]

	/**
	 * initMap
	 *
	 * Renders a Google Map onto the selected jQuery element
	 *
	 * @date    22/10/19
	 * @since   5.8.6
	 *
	 * @param   jQuery $el The jQuery element.
	 * @return  object The map instance.
	 */
	const initMap = ($el) => {
		// Find marker elements within map.
		let $markers = $el.find(".marker")

		let centreLat = $el.data("centre-lat")
		let centreLng = $el.data("centre-lng")

		// Create gerenic map.
		let mapArgs = {
			zoom: $el.data("zoom") || 8,
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			styles: mapStyles,
		}
		let map = new google.maps.Map($el[0], mapArgs)

		// Add markers.
		map.markers = []
		$markers.each((index, target) => {
			initMarker($(target), map)
		});

		let markerCluser = new MarkerClusterer({
			map: map,
			markers: map.markers,
		});

		console.log(markerCluser)

		if (centreLat && centreLng) {
			map.setCenter({
				lat: centreLat,
				lng: centreLng,
			})
			// Add a center marker
			// Create marker instance.
			let marker = new google.maps.Marker({
				position: {
					lat: centreLat,
					lng: centreLng,
				},
				map: map,
				icon: "/dist/brand/map-person-marker.svg",
			})

			// Show at least one nearest markers
			if (map.markers.length) {
				google.maps.event.addListenerOnce(map, "idle", function () {
					let shouldZoomOut = (map) => {
						let bounds = map.getBounds()
						for (let marker of map.markers) {
							if (bounds.contains(marker.getPosition())) {
								return false
							}
						}
						return true
					}

					while (shouldZoomOut(map)) {
						map.setZoom(map.getZoom() - 1)
					}
				})
			}
		} else {
			// Center map based on markers.
			centerMap(map)

			// Center in Adelaide / Zoom out to SA
			// map.setCenter({
			// 	lat: -34.906101,
			// 	lng: 138.593903,
			// });
			// map.setZoom(6);
		}

		// Return map instance.
		return map
	}

	/**
	 * initMarker
	 *
	 * Creates a marker for the given jQuery element and map.
	 *
	 * @date    22/10/19
	 * @since   5.8.6
	 *
	 * @param   jQuery $el The jQuery element.
	 * @param   object The map instance.
	 * @return  object The marker instance.
	 */
	const initMarker = ($marker, map) => {
		// Get position from marker.
		let latLng = {
			lat: $marker.data("lat"),
			lng: $marker.data("lng"),
		}

		// Create marker instance.
		let marker = new google.maps.Marker({
			position: latLng,
			map: map,
			icon: "/dist/brand/map-tooth-marker.svg",
		})

		// Append to reference for later use.
		map.markers.push(marker)

		// If marker contains HTML, add it to an infoWindow.
		if ($marker.html()) {
			// Create info window.
			let infowindow = new google.maps.InfoWindow({
				content: $marker.html(),
			})

			// Show info window when marker is clicked.
			google.maps.event.addListener(marker, "click", () => {
				infowindow.open(map, marker)
				map.setZoom(16)
				map.setCenter(marker.getPosition())
			})
		}
	}

	/**
	 * centerMap
	 *
	 * Centers the map showing all markers in view.
	 *
	 * @date    22/10/19
	 * @since   5.8.6
	 *
	 * @param   object The map instance.
	 * @return  void
	 */
	const centerMap = (map) => {
		// Create map boundaries from all map markers.
		const bounds = new google.maps.LatLngBounds()
		map.markers.forEach((marker) => {
			bounds.extend({
				lat: marker.position.lat(),
				lng: marker.position.lng(),
			})
		})

		// Case: Single marker.
		if (map.markers.length == 1) {
			map.setCenter(bounds.getCenter())

			// Case: Multiple markers.
		} else {
			// map.fitBounds( bounds );
			map.setCenter(bounds.getCenter())
		}
	}

	// Render maps on page load.
	$(".g-map").each((index, target) => {
		if (!$(target).length) return
		initMap($(target))
	})

	const find_clinic_form = document.querySelector("#findClinicsForm")
	if (find_clinic_form != null) {
		const latitude_input =
			find_clinic_form.querySelector("input[name='lat']")
		const longitude_input =
			find_clinic_form.querySelector("input[name='lng']")
		const suburb_search_field =
			find_clinic_form.querySelector("#suburbSearch")

		document
			.querySelector("[data-use-my-location]")
			.addEventListener("click", () => {
				navigator.geolocation.getCurrentPosition(
					(location) => {
						latitude_input.value = location.coords.latitude
						longitude_input.value = location.coords.longitude

						suburb_search_field.value = ""

						find_clinic_form.submit()
					},
					(error) => {
						alert(
							"We can't detect your current location: " +
								error.message
						)
					}
				)
			})

		const autocomplete = new google.maps.places.Autocomplete(
			suburb_search_field,
			{
				strictBounds: true,
				componentRestrictions: { country: "au" },
				locationRestriction: {
					north: -25.996373,
					south: -38.080941,
					east: 140.999388,
					west: 129.002018,
				}, // sa
				types: ["locality", "postal_code"],
				fields: ["geometry.location"],
			}
		)

		// submit form on selecting an autocomplete option
		autocomplete.addListener("place_changed", () => {
			const place = autocomplete.getPlace()

			if (!place.geometry || !place.geometry.location) {
				// User entered the name of a Place that was not suggested and
				// pressed the Enter key, or the Place Details request failed.
				window.alert(
					"No details available for input: '" + place.name + "'"
				)
				return
			}

			latitude_input.value = place.geometry.location.lat()
			longitude_input.value = place.geometry.location.lng()
			find_clinic_form.submit()

			// if(autocomplete.getPlace()["name"] == undefined) find_clinic_form.submit();
		})
	}
}

window.googleMaps = googleMaps
